import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';

import Content from 'src/componentes/pages/content';
import View from './view';
import qs from 'query-string';

@autobind
class Reuniao extends React.Component {
  render() {
    const { showOnlyList = false } = this.props;
    const responsaveis =
      location && qs.parse(location.search).responsaveis
        ? JSON.parse(decodeURIComponent(qs.parse(location.search).responsaveis))
        : location && qs.parse(location.search).responsavelId
        ? [
            {
              id: qs.parse(location.search).responsavelId,
              descricao: qs.parse(location.search).responsavelNome,
              nome: qs.parse(location.search).responsavelNome,
            },
          ]
        : null;

    const areaId =
      location && qs.parse(location.search).areaId
        ? qs.parse(location.search).areaId
        : null;

    const areaNome =
      location && qs.parse(location.search).areaNome
        ? qs.parse(location.search).areaNome
        : null;

    const areasSubordinadas =
      window.location && qs.parse(window.location.search).areasSubordinadas
        ? qs.parse(window.location.search).areasSubordinadas
        : null;

    const dataInicio =
      window.location && qs.parse(window.location.search).dataInicio
        ? qs.parse(window.location.search).dataInicio
        : null;

    const dataTermino =
      window.location && qs.parse(window.location.search).dataTermino
        ? qs.parse(window.location.search).dataTermino
        : null;

    let possuiParametrosUrl =
      (responsaveis && responsaveis.length > 0) ||
      areaId ||
      areaNome ||
      dataInicio ||
      dataTermino;

    return showOnlyList ? (
      <View {...this.props} />
    ) : (
      <Content
        titulo={<FormattedMessage id="reunioes" />}
        iconSettings={true}
        titleSettings={this.props.intl.formatMessage({
          id: 'label.configuracoesReuniao',
        })}
        urlSettings="/configuracoes/reuniao"
        endPointPermissionSettings="/itemConfiguracaoReuniao/PossuiPermissaoConfiguracao"
      >
        <View
          selectedFilter={
            possuiParametrosUrl && {
              valor: {
                ...(responsaveis && { responsaveis: responsaveis }),
                ...(areaId && {
                  areas: [
                    {
                      id: areaId,
                      nome: areaNome,
                    },
                  ],
                }),
                ...(areasSubordinadas && { areasSubordinadas: true }),
                ...(dataInicio && { dataInicioItem: new Date(dataInicio) }),
                ...(dataTermino && {
                  dataTerminoItem: new Date(dataTermino),
                }),
              },
            }
          }
          openLastFilter={!possuiParametrosUrl}
          forceSelectedFilter={possuiParametrosUrl}
          {...this.props}
          stickyHeader
        />
      </Content>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(connect(mapStateToProps)(Reuniao));
